import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { ROLES } from '../Types/constants';

interface AuthState {
  accessToken: string | null;
  user: LoggedUser | null;
  loading: boolean;
  isAuthenticated: boolean;
  setAccessToken: (token: string | null) => void;
  setUser: (user: LoggedUser | null) => void;
  setLoading: (loading: boolean) => void;
}

export interface LoggedUser {
  id: number;
  fullName: string;
  email: string;
  roles: string[];
  isRecruiter?: boolean;
  isAdmin?: boolean;
  isInternal?: boolean;
  isOperations?: boolean;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      accessToken: null,
      user: null,
      loading: false,
      isAuthenticated: false,
      setAccessToken: (token: string | null) => {
        set({ accessToken: token });
        set({ isAuthenticated: !!token && !!get().user });
      },
      setUser: (user) => {
        if (user) {
          user.isAdmin = user.roles?.includes(ROLES.admin);
          user.isRecruiter = user.roles?.includes(ROLES.recruiter);
          user.isInternal = user.roles?.includes(ROLES.internal);
          user.isOperations = user.roles?.includes(ROLES.operations);
        }
        set({ user, loading: false });
        set({ isAuthenticated: !!get().accessToken && !!user });
      },
      setLoading: (loading) => set({ loading }),
    }),
    {
      name: 'authStore',
    },
  ),
);
